"use client";

import { useSiteLocale } from "@/components/layout/CcLocaleContext";
import { CcButton } from "@/components/ui/CcButton";
import { getCookieConsentCopy } from "@/lib/cookie-consent-copy";
import { openCookiePreferences } from "@/lib/cookie-consent";

type CcCookiePreferencesTriggerProps = {
  label?: string;
  className?: string;
};

export function CcCookiePreferencesTrigger({
  label,
  className = "",
}: CcCookiePreferencesTriggerProps) {
  const locale = useSiteLocale();
  const resolvedLabel = label ?? getCookieConsentCopy(locale).trigger.label;
  return (
    <CcButton
      type="button"
      variant="outline"
      label={resolvedLabel}
      className={className}
      onClick={() => openCookiePreferences({ manage: true })}
    />
  );
}
